/* ══════════════════════════════════════════════════════════════════════
   What the right-click copy menu can offer for one client (a contact, a
   site contact or an account): its name, email and phone.

   The console's records name these fields differently - a contact has
   first_name + last_name, `contact_email` (else `email`) and `mobile`, an
   account `company_name` and `business_phone`, a site contact `name`, `email`
   and `number` - so the directive takes the record as it comes and reads it
   here, instead of every template building the object by hand.
   ══════════════════════════════════════════════════════════════════════ */

export interface CopyContact {
  name?: string;
  email?: string;
  phone?: string;
}

/** a bare string is a name; anything else is read for the usual field names */
export type CopySource = string | CopyContact | object | null | undefined;

const text = (v: unknown): string => (typeof v === 'string' || typeof v === 'number') ? String(v).trim() : '';

const first = (...values: unknown[]): string => {
  for (const v of values) {
    const t = text(v);
    if (t) { return t; }
  }
  return '';
};

export function toCopyContact(v: CopySource): CopyContact {
  if (!v) { return {}; }
  if (typeof v === 'string') { return {name: v.trim() || undefined}; }
  const r = v as Record<string, any>;
  const fullName = [text(r['first_name']), text(r['last_name'])].filter(Boolean).join(' ');
  const name = first(r['name'], r['full_name'], fullName, r['contact_name'], r['account_name'], r['company_name']);
  // a contact's own email wins over its login email, as on the contact screens
  const email = first(r['contact_email'], r['email'], r['email_address']);
  const phone = first(r['phone'], r['mobile'], r['number'], r['business_phone'], r['phone_number'],
    r['mobile_number'], r['contact_number']);
  return {name: name || undefined, email: email || undefined, phone: phone || undefined};
}
